module.exports = __webpack_public_path__ + "static/media/My Parties_active_Blue.7230cbd5.svg";